// extracted by mini-css-extract-plugin
export default {"addToCartControl":"L1-z","giftCard":"M1-z","btnContainer":"N1-z","cartButton":"O1-z","disabled":"P1-z"};